import { format, parseISO } from 'date-fns';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DatePicker } from '@/components/common/DatePicker';
import { Field, FieldLabel } from '@/components/shadcn/field';

import type { CreatePartyValues } from './types';

const EARLIEST_BIRTH_MONTH = new Date(1900, 0);

export default function BirthdateField() {
  const { t } = useTranslation();

  const { control } = useFormContext<CreatePartyValues>();

  return (
    <Controller
      control={control}
      name="birthdate"
      render={({ field }) => (
        <Field>
          <FieldLabel htmlFor="birthdate">
            {t('PARTY_CREATE_INLINE_BIRTHDATE_LABEL')}
          </FieldLabel>

          <DatePicker
            id="birthdate"
            value={field.value ? parseISO(field.value) : undefined}
            onChange={(date) =>
              field.onChange(date ? format(date, 'yyyy-MM-dd') : undefined)
            }
            startMonth={EARLIEST_BIRTH_MONTH}
            endMonth={new Date()}
          />
        </Field>
      )}
    />
  );
}
